import {gql} from '@apollo/client';

export const LIST_3RD_PARTY = gql`
  query curoEntity($name: String) {
    curoEntity(fieldName: "third_party", name: $name) {
      id
      name
    }
  }
`;
